{
  "app.name": "Cargofollow",
  "nav.dashboard.label": "Übersicht",
  "nav.shipments.label": "Sendungen",
  "nav.api_keys.label": "API-Keys",
  "nav.webhooks.label": "Webhooks",
  "nav.events.label": "Ereignisse",
  "nav.logs.label": "Logs",
  "nav.settings.label": "Einstellungen",
  "nav.conformance.label": "Konformität",
  "nav.billing.label": "Abrechnung",
  "nav.label": "Konsolennavigation",
  "language.label": "Sprache",
  "language.nl": "Niederländisch",
  "language.en": "Englisch",
  "language.de": "Deutsch",
  "loading": "Wird geladen…",
  "button.retry": "Erneut versuchen",
  "button.sign_out": "Abmelden",
  "error.title": "Etwas ist schiefgelaufen",
  "error.body": "Versuchen Sie es erneut. Bleibt der Fehler bestehen, melden Sie sich bei uns.",
  "error.not_found.title": "Seite nicht gefunden",
  "error.not_found.body": "Diese Seite gibt es nicht (mehr).",
  "error.network": "Keine Verbindung zur API.",
  "error.unexpected": "Unerwarteter Fehler.",
  "login.title": "Anmelden",
  "login.intro": "Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link, der Sie direkt anmeldet.",
  "login.email.label": "E-Mail-Adresse",
  "login.submit": "Anmeldelink senden",
  "login.sent.title": "Prüfen Sie Ihr Postfach",
  "login.sent.body": "Wir haben einen Anmeldelink an {email} geschickt. Der Link gilt 15 Minuten.",
  "login.to_signup": "Noch kein Konto? Jetzt anlegen.",
  "signup.title": "Konto anlegen",
  "signup.intro": "In einer Minute zum Sandbox-Key. Ohne Kreditkarte, ohne Verkaufsgespräch.",
  "signup.name.label": "Ihr Name",
  "signup.organization.label": "Firmenname",
  "signup.email.label": "Geschäftliche E-Mail-Adresse",
  "signup.submit": "Konto anlegen",
  "signup.sent.title": "Nur noch ein Klick",
  "signup.sent.body": "Wir haben einen Bestätigungslink an {email} geschickt. Öffnen Sie ihn, um Ihre Organisation anzulegen.",
  "signup.to_login": "Sie haben bereits ein Konto? Melden Sie sich an.",
  "welcome.title": "Willkommen bei Cargofollow",
  "welcome.intro": "Ihre Organisation {organization} steht bereit, mit einem Sandbox-Key.",
  "welcome.key.label": "Ihr sk_test_-Key",
  "welcome.key.once": "Dieser Key wird genau einmal angezeigt. Speichern Sie ihn jetzt; danach können Sie nur einen neuen erstellen.",
  "welcome.key.copy": "Key kopieren",
  "welcome.key.copied": "Kopiert",
  "welcome.key.gone.title": "Der Key wurde bereits angezeigt",
  "welcome.key.gone.body": "Aus Sicherheitsgründen zeigen wir einen Key nur einmal. Erstellen Sie unter API-Keys einen neuen.",
  "welcome.quickstart.title": "Gleich ausprobieren",
  "welcome.quickstart.body": "Legen Sie Ihre erste Sendung mit diesem curl an:",
  "welcome.continue": "Zur Übersicht",
  "live.title": "Live gehen",
  "live.body": "sk_live_-Keys schaltet Cargofollow manuell frei, nachdem Sie die Konformitätscheckliste durchlaufen haben. Bis dahin arbeiten Sie mit sk_test_ in der Sandbox.",
  "live.request": "Live-Zugang anfragen",
  "dashboard.title": "Übersicht",
  "dashboard.intro": "Hier erscheinen Ihre Sendungen, Keys, Webhooks und Logs.",
  "email.magic_link.subject": "Ihr Anmeldelink für Cargofollow",
  "email.magic_link.body": "Klicken Sie auf diesen Link, um sich in der Cargofollow-Konsole anzumelden: {url}",
  "email.magic_link.ignore": "Sie haben das nicht angefordert? Dann können Sie diese Nachricht ignorieren.",
  "login.error.unknown_email": "Für diese Adresse gibt es kein Konto, oder Ihre Einladung ist abgelaufen. Legen Sie ein Konto an.",
  "settings.title": "Einstellungen",
  "settings.nav.members": "Mitglieder",
  "members.title": "Mitglieder",
  "members.intro": "Wer in dieser Organisation was darf. Eine Rolle bestimmt nur, was Sie in der Konsole sehen und tun dürfen; was ein API-Key darf, steht in dessen Scopes.",
  "members.column.member": "Mitglied",
  "members.column.role": "Rolle",
  "members.column.actions": "Aktionen",
  "members.you": "Sie",
  "members.empty": "Es gibt noch keine weiteren Mitglieder.",
  "members.role.label": "Rolle von {name}",
  "members.role.owner": "Eigentümer",
  "members.role.admin": "Administrator",
  "members.role.developer": "Entwickler",
  "members.role.viewer": "Betrachter",
  "members.role.owner.hint": "Alles, einschließlich Organisation löschen und Eigentum übertragen.",
  "members.role.admin.hint": "Alles außer Organisation löschen und Eigentümer wechseln.",
  "members.role.developer.hint": "Keys, Webhooks und Sendungen lesen und schreiben; keine Mitglieder.",
  "members.role.viewer.hint": "Nur lesen.",
  "members.remove": "Entfernen",
  "members.remove.confirm": "{name} aus dieser Organisation entfernen?",
  "members.last_owner": "Der letzte Eigentümer kann weder entfernt noch herabgestuft werden.",
  "members.forbidden.title": "Kein Zugriff auf Mitglieder",
  "members.forbidden.body": "Ihre Rolle darf die Mitgliederliste nicht sehen. Bitten Sie einen Administrator um Zugriff.",
  "invite.title": "Kollegin oder Kollegen einladen",
  "invite.email.label": "E-Mail-Adresse",
  "invite.role.label": "Rolle",
  "invite.submit": "Einladung senden",
  "invite.sent": "Einladung an {email} gesendet.",
  "invitations.title": "Offene Einladungen",
  "invitations.empty": "Keine offenen Einladungen.",
  "invitations.expires": "Läuft ab {expires}",
  "invitations.revoke": "Zurückziehen",
  "accept.title": "Sie wurden eingeladen",
  "accept.intro": "{organization} lädt Sie als {role} ein. Wir senden einen Anmeldelink an {email}; damit werden Sie sofort Mitglied.",
  "accept.submit": "Annehmen und anmelden",
  "accept.sent.title": "Prüfen Sie Ihr Postfach",
  "accept.sent.body": "Wir haben einen Anmeldelink an {email} geschickt. Öffnen Sie ihn, um beizutreten.",
  "accept.invalid.title": "Diese Einladung ist nicht mehr gültig",
  "accept.invalid.body": "Die Einladung wurde zurückgezogen, ist abgelaufen oder wurde bereits verwendet. Bitten Sie um eine neue.",
  "api_keys.new": "Neuer Key",
  "api_keys.new.hint": "Erstellen Sie einen neuen Key. Das Geheimnis sehen Sie genau einmal.",
  "button.cancel": "Abbrechen",
  "button.copy": "Kopieren",
  "button.copied": "Kopiert",
  "mode.label": "Modus",
  "mode.test": "Test",
  "mode.live": "Live",
  "mode.live.disabled": "Live ist für diese Organisation noch nicht aktiviert.",
  "api_keys.intro": "Keys authentifizieren Ihre API-Aufrufe. Ein Key gehört zu einem Modus: sk_test_ trifft die Sandbox, sk_live_ die echte Welt.",
  "api_keys.column.name": "Name",
  "api_keys.column.prefix": "Key",
  "api_keys.column.scopes": "Scopes",
  "api_keys.column.created_by": "Erstellt von",
  "api_keys.column.last_used": "Zuletzt benutzt",
  "api_keys.column.actions": "Aktionen",
  "api_keys.status.revoked": "Widerrufen",
  "api_keys.never_used": "Noch nicht benutzt",
  "api_keys.unknown_creator": "Bei der Anmeldung",
  "api_keys.empty": "In diesem Modus gibt es noch keine Keys.",
  "api_keys.revoke": "Widerrufen",
  "api_keys.revoke.confirm": "Key {name} widerrufen? Aufrufe mit diesem Key schlagen sofort fehl.",
  "api_keys.form.title": "Neuer Key",
  "api_keys.form.name": "Name",
  "api_keys.form.name.hint": "Wofür benutzen Sie ihn? Zum Beispiel: Backend Produktion.",
  "api_keys.form.mode": "Modus",
  "api_keys.form.scopes": "Scopes",
  "api_keys.form.submit": "Key erstellen",
  "api_keys.created.title": "Ihr neuer Key",
  "api_keys.created.once": "Dieser Key wird genau einmal angezeigt. Speichern Sie ihn jetzt; danach sehen Sie nur noch das Präfix.",
  "api_keys.created.done": "Ich habe ihn gespeichert",
  "api_keys.live.blocked": "Live-Keys aktiviert Cargofollow manuell, nach der Konformitäts-Checkliste. Beantragen Sie Live-Zugang; wir melden uns.",
  "live.request.sent": "Ihre Anfrage wurde gesendet. Wir melden uns unter {email}.",
  "live.request.note": "Hinweis (optional)",
  "conformance.intro": "Bevor Sie live gehen, möchten wir sehen, dass Ihre Integration auch das beherrscht, was in der Produktion schiefgeht. Diese zwölf Szenarien liest die Checkliste aus Ihren eigenen Ereignissen, Logs und Webhook-Zustellungen im Testmodus zurück.",
  "conformance.progress": "{passed} von {total} Szenarien nachgewiesen",
  "conformance.checked": "Zuletzt geprüft am {moment}",
  "conformance.never_checked": "Noch nicht geprüft",
  "conformance.recheck": "Jetzt prüfen",
  "conformance.ready.title": "Bereit für live",
  "conformance.ready.body": "Alle Szenarien sind nachgewiesen. Beantragen Sie den Livezugang; Cargofollow schaltet sk_live_-Keys manuell frei.",
  "conformance.blocked": "Der Livezugang lässt sich beantragen, sobald alle zwölf Szenarien nachgewiesen sind.",
  "conformance.blocked.title": "Noch nicht bereit für live",
  "conformance.requested": "Livezugang beantragt am {moment}.",
  "conformance.enabled.title": "Ihre Organisation ist bereits live",
  "conformance.enabled.body": "sk_live_-Keys sind aktiv. Die Checkliste bleibt als Nachweis dessen stehen, was Sie in der Sandbox gezeigt haben.",
  "conformance.table.caption": "Conformance-Szenarien",
  "conformance.column.status": "Status",
  "conformance.column.scenario": "Szenario",
  "conformance.column.moment": "Nachgewiesen",
  "conformance.status.passed": "Nachgewiesen",
  "conformance.status.pending": "Noch nicht nachgewiesen",
  "conformance.status.failed": "Fehlgeschlagen",
  "conformance.hint": "Wie weise ich das nach?",
  "conformance.scenario.create_shipment.title": "Sendung anlegen",
  "conformance.scenario.create_shipment.body": "Sie haben mit POST /v1/shipments eine Sendung angelegt.",
  "conformance.scenario.validate_with_error_handled.title": "Einen Fehler behandeln",
  "conformance.scenario.validate_with_error_handled.body": "Sie haben bei einem ungültigen Body eine 422 erhalten und danach eine Sendung angelegt.",
  "conformance.scenario.issue.title": "Ausstellen",
  "conformance.scenario.issue.body": "Sie haben eine Sendung ausgestellt, womit Version 1 des Frachtbriefs festgehalten wurde.",
  "conformance.scenario.signature_via_link.title": "Über einen Link unterschreiben",
  "conformance.scenario.signature_via_link.body": "Es wurde über einen Signaturlink unterschrieben, ohne API-Key.",
  "conformance.scenario.delivery_with_pod.title": "Zustellen mit ePOD",
  "conformance.scenario.delivery_with_pod.body": "Sie haben eine Sendung zugestellt und den Ablieferbeleg zurückgelesen.",
  "conformance.scenario.webhook_endpoint_configured.title": "Webhook-Endpunkt eingerichtet",
  "conformance.scenario.webhook_endpoint_configured.body": "Sie haben einen Endpunkt angemeldet, an den Ereignisse gehen.",
  "conformance.scenario.webhook_echo_verified.title": "Echo-Header bestätigt",
  "conformance.scenario.webhook_echo_verified.body": "Ihr Empfänger hat einen Ping mit demselben freightapi-echo-Header beantwortet, den wir mitgeschickt haben.",
  "conformance.scenario.webhook_delivery_succeeded.title": "Zustellung erfolgreich",
  "conformance.scenario.webhook_delivery_succeeded.body": "Ihr Empfänger hat ein echtes Ereignis mit einer 2xx angenommen.",
  "conformance.scenario.idempotency_key_used.title": "Idempotency-Key verwendet",
  "conformance.scenario.idempotency_key_used.body": "Sie haben ein POST mit einem Idempotency-Key gesendet, sodass ein wiederholter Aufruf keine zweite Sendung erzeugt.",
  "conformance.scenario.integrity_checked.title": "Hash-Kette geprüft",
  "conformance.scenario.integrity_checked.body": "Sie haben den Integritätsbericht einer Sendung abgerufen.",
  "conformance.scenario.pdf_downloaded.title": "PDF heruntergeladen",
  "conformance.scenario.pdf_downloaded.body": "Sie haben den Frachtbrief als PDF abgerufen.",
  "conformance.scenario.auto_sandbox_run.title": "Sandbox-Lauf mit auto",
  "conformance.scenario.auto_sandbox_run.body": "Sie haben eine Sandbox-Sendung mit action: auto den gesamten Lebenszyklus durchlaufen lassen.",
  "webhooks.intro": "Webhook-Endpunkte empfangen Events von Cargofollow. Jede Zustellung ist mit dem Secret des Endpunkts signiert.",
  "webhooks.column.url": "URL",
  "webhooks.column.events": "Events",
  "webhooks.column.status": "Status",
  "webhooks.column.actions": "Aktionen",
  "webhooks.status.active": "Aktiv",
  "webhooks.status.inactive": "Inaktiv",
  "webhooks.empty": "In diesem Modus gibt es noch keine Endpunkte.",
  "webhooks.new": "Neuer Endpunkt",
  "webhooks.form.title": "Neuer Endpunkt",
  "webhooks.form.url": "URL",
  "webhooks.form.events": "Events",
  "webhooks.form.events.hint": "Kommagetrennt: shipment.*, signature.completed, oder * für alles.",
  "webhooks.form.description": "Beschreibung",
  "webhooks.form.submit": "Endpunkt erstellen",
  "webhooks.secret.title": "Das Secret dieses Endpunkts",
  "webhooks.secret.once": "Dieses Secret wird genau einmal angezeigt. Speichern Sie es; damit prüfen Sie die Signatur jeder Zustellung.",
  "webhooks.test": "Test senden",
  "webhooks.test.result": "HTTP {status} in {duration} ms",
  "webhooks.test.failed": "Fehlgeschlagen nach {duration} ms: {error}",
  "webhooks.pause": "Pausieren",
  "webhooks.activate": "Aktivieren",
  "webhooks.delete": "Löschen",
  "webhooks.delete.confirm": "Endpunkt {url} löschen? Zustellungen stoppen sofort.",
  "settings.nav.organization": "Organisation",
  "organization.title": "Organisation",
  "organization.intro": "Der Name auf Dokumenten, der Provider, der eine Sendung ausführt, und wie lange wir Daten aufbewahren.",
  "organization.name.label": "Name",
  "organization.default_provider.label": "Standardprovider",
  "organization.default_provider.hint": "Der Provider, den eine Sendung bekommt, wenn der Aufruf keinen nennt.",
  "organization.providers.label": "Erlaubte Provider",
  "organization.providers.hint": "Nur diese Provider können für eine Sendung gewählt werden.",
  "organization.retention.label": "Aufbewahrung (Tage)",
  "organization.retention.hint": "Zwischen 30 und 3650 Tagen.",
  "organization.save": "Speichern",
  "organization.saved": "Einstellungen gespeichert.",
  "shipments.intro": "Alle Sendungen in diesem Modus, neueste zuerst.",
  "shipments.filter.status": "Status",
  "shipments.filter.status.any": "Alle Status",
  "shipments.filter.reference": "Referenz",
  "shipments.filter.provider": "Provider",
  "shipments.filter.provider.any": "Alle Provider",
  "shipments.filter.created_after": "Erstellt ab",
  "shipments.filter.created_before": "Erstellt bis einschließlich",
  "shipments.filter.apply": "Filtern",
  "shipments.filter.reset": "Zurücksetzen",
  "shipments.column.reference": "Referenz",
  "shipments.column.status": "Status",
  "shipments.column.route": "Strecke",
  "shipments.column.provider": "Provider",
  "shipments.column.created": "Erstellt",
  "shipments.version": "Version {version}",
  "shipments.empty.title": "Keine Sendungen",
  "shipments.empty.body": "Keine Sendung passt zu diesen Filtern. Legen Sie eine über die API an oder passen Sie die Filter an.",
  "shipments.page.previous": "Zurück",
  "shipments.page.next": "Weiter",
  "shipments.detail.back": "Zurück zu den Sendungen",
  "shipments.detail.created": "Erstellt am {timestamp}",
  "shipments.tabs.label": "Registerkarten dieser Sendung",
  "shipments.tab.overview": "Übersicht",
  "shipments.tab.timeline": "Verlauf",
  "shipments.tab.documents": "Dokumente",
  "shipments.tab.signatures": "Unterschriften",
  "shipments.tab.pod": "POD",
  "shipments.tab.provider": "Provider",
  "shipments.tab.webhooks": "Webhooks",
  "shipments.tab.raw": "Rohes JSON",
  "shipments.tab.authorisations": "Berechtigungen",
  "shipments.authorisations.title": "Berechtigungsregister",
  "shipments.authorisations.intro": "Wer welchen Vorgang auf diesem eFTI-Datensatz ausführen darf, wie lange und über welchen Teil der Daten (Artikel 5 der Durchführungsverordnung (EU) 2025/2243). Entzogene Rechte bleiben stehen: Das Register muss genauso lange prüfbar bleiben wie der Datensatz selbst.",
  "shipments.authorisations.dataset": "Datensatz-UUID: {uuid}",
  "shipments.authorisations.dataset.none": "Noch kein eFTI-Datensatz; die Rechte gelten, sobald es einen gibt.",
  "shipments.authorisations.column.party": "Partei",
  "shipments.authorisations.column.role": "Rolle",
  "shipments.authorisations.column.operations": "Vorgänge",
  "shipments.authorisations.column.window": "Gültig",
  "shipments.authorisations.column.status": "Status",
  "shipments.authorisations.column.actions": "Aktionen",
  "shipments.authorisations.scope.all": "Gesamter gemeinsamer Datensatz",
  "shipments.authorisations.until.none": "unbefristet",
  "shipments.authorisations.baseline": "Nicht entziehbar",
  "shipments.authorisations.revoke": "Entziehen",
  "shipments.authorisations.revoke.confirm": "Dieses Recht entziehen? Der Eintrag bleibt im Register, mit dem Zeitpunkt des Entzugs.",
  "shipments.authorisations.revoke.done": "Recht entzogen.",
  "shipments.authorisations.empty.title": "Kein Register",
  "shipments.authorisations.empty.body": "Diese Sendung hat kein Berechtigungsregister. Gibt es sie in diesem Modus?",
  "shipments.authorisations.grant.title": "Recht erteilen",
  "shipments.authorisations.grant.intro": "Die Vorgänge ergeben sich aus der Rolle. Eine Partei ohne Cargofollow-Konto wird über eine E-Mail-Adresse benannt und bekommt immer ein Enddatum.",
  "shipments.authorisations.grant.party_type": "Art der Partei",
  "shipments.authorisations.grant.party_ref": "Id der Partei",
  "shipments.authorisations.grant.email": "E-Mail-Adresse",
  "shipments.authorisations.grant.role": "Rolle",
  "shipments.authorisations.grant.valid_until": "Gültig bis",
  "shipments.authorisations.grant.valid_until.hint": "Pflicht für eine Partei ohne Konto, und höchstens 90 Tage.",
  "shipments.authorisations.grant.submit": "Erteilen",
  "shipments.authorisations.grant.done": "Recht erteilt.",
  "shipments.authorisations.party_type.organization": "Organisation",
  "shipments.authorisations.party_type.member": "Benutzer",
  "shipments.authorisations.party_type.api_key": "API-Schlüssel",
  "shipments.authorisations.party_type.contact": "Kontakt ohne Konto",
  "shipments.authorisations.party_type.authority": "Behörde",
  "shipments.authorisations.role.data_holder": "Dateninhaber",
  "shipments.authorisations.role.consignor": "Absender",
  "shipments.authorisations.role.carrier": "Frachtführer",
  "shipments.authorisations.role.consignee": "Empfänger",
  "shipments.authorisations.role.authority": "Behörde",
  "shipments.authorisations.role.other": "Sonstige",
  "shipments.authorisations.status.active": "Aktiv",
  "shipments.authorisations.status.scheduled": "Geplant",
  "shipments.authorisations.status.expired": "Abgelaufen",
  "shipments.authorisations.status.revoked": "Entzogen",
  "shipments.authorisations.source.baseline": "Dateninhaber",
  "shipments.authorisations.source.granted": "Erteilt",
  "shipments.authorisations.source.derived": "Automatisch",
  "shipments.processing.title": "Verarbeitungsprotokoll",
  "shipments.processing.intro": "Jeder Vorgang auf diesem Datensatz, neueste zuerst, wie Artikel 9 Absatz 5 es verlangt. Ablehnungen stehen ebenfalls darin, und der Zugriff einer Behörde über ein nationales eFTI-Gate auch.",
  "shipments.processing.empty": "Noch keine Vorgänge erfasst.",
  "shipments.processing.column.moment": "Zeitpunkt",
  "shipments.processing.column.operation": "Vorgang",
  "shipments.processing.column.party": "Partei",
  "shipments.processing.column.outcome": "Ergebnis",
  "shipments.processing.outcome.allowed": "Zugelassen",
  "shipments.processing.outcome.refused": "Abgelehnt",
  "shipments.processing.operation.create": "Anlegen",
  "shipments.processing.operation.edit": "Bearbeiten",
  "shipments.processing.operation.read": "Lesen",
  "shipments.processing.operation.download": "Herunterladen",
  "shipments.processing.operation.consignor_signature": "Unterschrift Absender",
  "shipments.processing.operation.carrier_signature": "Unterschrift Frachtführer",
  "shipments.processing.operation.consignee_signature": "Unterschrift Empfänger",
  "shipments.processing.operation.combined_transport_stamp": "Stempel kombinierter Verkehr",
  "shipments.processing.operation.archive": "Archivieren",
  "shipments.processing.operation.waste_documents_download": "Abfalldokumente herunterladen",
  "shipments.processing.operation.waste_carrier_confirmation": "Bestätigung Abfallbeförderer",
  "shipments.not_found.title": "Sendung nicht gefunden",
  "shipments.not_found.body": "Diese Sendung gibt es in dieser Organisation und diesem Modus nicht. Vielleicht liegt sie im anderen Modus?",
  "shipments.more": "Mehr laden",
  "shipments.integrity.ok": "Kette intakt",
  "shipments.integrity.ok.detail": "{events} Ereignisse, seit dem Anlegen ununterbrochen.",
  "shipments.integrity.broken": "Kette unterbrochen",
  "shipments.integrity.broken.detail": "Ab Seq {seq} geht die Kette nicht mehr auf.",
  "shipments.integrity.gaps": "Fehlende Folgenummern: {gaps}",
  "shipments.integrity.head": "Kopf-Hash",
  "shipments.integrity.verified_at": "Geprüft am {timestamp}",
  "shipments.events.title": "Ereignisse und Hashes",
  "shipments.events.column.seq": "Seq",
  "shipments.events.column.event": "Ereignis",
  "shipments.events.column.occurred": "Zeitpunkt",
  "shipments.events.column.actor": "Akteur",
  "shipments.events.column.hash": "Hash",
  "shipments.events.column.prev_hash": "Vorheriger Hash",
  "shipments.trace.title": "API-Aufrufe",
  "shipments.trace.intro": "Die Aufrufe, die diese Sendung genannt haben, neueste zuerst.",
  "shipments.trace.empty": "Keine Aufrufe innerhalb der Aufbewahrungsfrist der Logs.",
  "shipments.trace.column.call": "Aufruf",
  "shipments.trace.column.status": "Status",
  "shipments.trace.column.duration": "Dauer",
  "shipments.trace.column.request_id": "Request-ID",
  "shipments.trace.column.moment": "Zeitpunkt",
  "shipments.signatures.empty": "Es wurde noch nicht unterschrieben.",
  "shipments.signatures.column.role": "Rolle",
  "shipments.signatures.column.signer": "Unterzeichner",
  "shipments.signatures.column.method": "Methode",
  "shipments.signatures.column.signed_at": "Unterschrieben am",
  "shipments.signatures.column.hash": "Versions-Hash",
  "shipments.pod.empty.title": "Noch kein Ablieferbeleg",
  "shipments.pod.empty.body": "Der Ablieferbeleg erscheint, sobald der Empfänger bei der Ablieferung unterschrieben hat.",
  "shipments.pod.delivered_at": "Abgeliefert am",
  "shipments.pod.signed_by": "Unterschrieben von",
  "shipments.pod.colli": "Packstücke",
  "shipments.pod.remarks": "Vorbehalte",
  "shipments.pod.remarks.empty": "Keine Vorbehalte bei der Ablieferung.",
  "shipments.pod.photos": "Fotos",
  "shipments.pod.pdf": "Ablieferbeleg (PDF)",
  "shipments.pod.pdf.none": "Es liegt noch kein PDF bereit.",
  "shipments.provider.empty.title": "Noch keine Provider-Verknüpfung",
  "shipments.provider.empty.body": "Eine Sendung bekommt eine Verknüpfung, sobald sie ausgestellt ist und die Synchronisation gelaufen ist.",
  "shipments.provider.provider": "Provider",
  "shipments.provider.status": "Synchronisationsstatus",
  "shipments.provider.external_id": "Externe ID",
  "shipments.provider.last_operation": "Letzter Vorgang",
  "shipments.provider.last_synced": "Zuletzt synchronisiert",
  "shipments.provider.error": "Letzter Fehler",
  "shipments.provider.retry": "Erneut synchronisieren",
  "shipments.provider.retry.started": "Die Synchronisation wurde erneut gestartet. Laden Sie in ein paar Sekunden neu.",
  "shipments.provider.status.pending": "In Bearbeitung",
  "shipments.provider.status.synced": "Synchronisiert",
  "shipments.provider.status.failed": "Fehlgeschlagen",
  "shipments.provider.status.cancelled": "Storniert",
  "shipments.provider.trace.title": "Trace",
  "shipments.provider.trace.empty": "Die Synchronisation hat noch keinen Schritt aufgezeichnet.",
  "shipments.provider.trace.column.step": "Schritt",
  "shipments.provider.trace.column.outcome": "Ergebnis",
  "shipments.provider.trace.column.detail": "Erläuterung",
  "shipments.provider.trace.column.moment": "Zeitpunkt",
  "shipments.provider.step.normalize": "Normalisieren",
  "shipments.provider.step.validate": "Prüfen",
  "shipments.provider.step.select": "Provider wählen",
  "shipments.provider.step.publish": "Veröffentlichen",
  "shipments.provider.step.status": "Status abrufen",
  "shipments.provider.outcome.ok": "Erfolgreich",
  "shipments.provider.outcome.skipped": "Übersprungen",
  "shipments.provider.outcome.failed": "Fehlgeschlagen",
  "shipments.webhooks.empty": "Für diese Sendung gibt es noch keine Zustellungen.",
  "shipments.webhooks.column.event": "Event",
  "shipments.webhooks.column.status": "Status",
  "shipments.webhooks.column.attempt": "Versuch",
  "shipments.webhooks.column.response": "Antwort",
  "shipments.webhooks.column.moment": "Zeitpunkt",
  "shipments.webhooks.status.pending": "In der Warteschlange",
  "shipments.webhooks.status.succeeded": "Erfolgreich",
  "shipments.webhooks.status.failed": "Fehlgeschlagen",
  "shipments.webhooks.status.dead": "Aufgegeben",
  "shipments.raw.intro": "Die aktuelle Version dieser Sendung, genau so, wie die API sie zurückgibt.",
  "shipments.raw.copy": "JSON kopieren",
  "shipments.raw.copied": "Kopiert",
  "button.close": "Schließen",
  "filter.apply": "Filtern",
  "filter.reset": "Zurücksetzen",
  "page.previous": "Zurück",
  "page.next": "Weiter",
  "webhooks.nav.endpoints": "Endpunkte",
  "webhooks.nav.deliveries": "Zustellungen",
  "deliveries.intro": "Was Cargofollow an Ihre Endpunkte gesendet hat, neueste zuerst. Öffnen Sie ein Ereignis für den genauen Inhalt, die Antwort und den Verlauf der Versuche.",
  "deliveries.table.caption": "Webhook-Zustellungen",
  "deliveries.empty.title": "Noch keine Zustellungen",
  "deliveries.empty.body": "Sobald ein Endpunkt ein Ereignis abonniert hat, erscheint hier jede Sendung.",
  "deliveries.column.event": "Ereignis",
  "deliveries.column.endpoint": "Endpunkt",
  "deliveries.column.status": "Status",
  "deliveries.column.attempts": "Versuche",
  "deliveries.column.response": "Letzte Antwort",
  "deliveries.column.moment": "Zeitpunkt",
  "deliveries.status.pending": "In Warteschlange",
  "deliveries.status.succeeded": "Erfolgreich",
  "deliveries.status.failed": "Fehlgeschlagen",
  "deliveries.status.dead": "Aufgegeben",
  "deliveries.attempts": "{attempt} von {max}",
  "deliveries.no_response": "Keine Antwort",
  "deliveries.filter.status": "Status",
  "deliveries.filter.status.any": "Alle Status",
  "deliveries.filter.endpoint": "Endpunkt",
  "deliveries.filter.endpoint.any": "Alle Endpunkte",
  "deliveries.filter.event": "Ereignis",
  "deliveries.filter.event.any": "Alle Ereignisse",
  "deliveries.detail.title": "Zustellung",
  "deliveries.detail.event_id": "Ereignis-ID",
  "deliveries.detail.timeline": "Verlauf der Versuche",
  "deliveries.detail.attempt": "Sendung {number} · {status}",
  "deliveries.detail.answered": "Antwortete {status} in {duration} ms",
  "deliveries.detail.request_headers": "Request-Header",
  "deliveries.detail.request_body": "Gesendeter Inhalt",
  "deliveries.detail.response_body": "Antwort des Empfängers",
  "deliveries.detail.none": "Nichts erfasst.",
  "deliveries.replay": "Erneut senden",
  "events.intro": "Jedes Ereignis jeder Sendung in dieser Organisation, neueste zuerst. Dieselben Zeilen, die eine Integration über GET /v1/events abruft.",
  "events.table.caption": "Ereignisse",
  "events.empty.title": "Noch keine Ereignisse",
  "events.empty.body": "Sobald eine Sendung angelegt wird, erscheint hier ihr erstes Ereignis.",
  "events.column.type": "Ereignis",
  "events.column.shipment": "Sendung",
  "events.column.actor": "Von",
  "events.column.seq": "Nr.",
  "events.column.moment": "Zeitpunkt",
  "events.filter.type": "Art",
  "events.filter.type.any": "Alle Arten",
  "logs.intro": "Jeder API-Aufruf dieser Organisation, mit Status, Dauer und dem Fehlercode eines Fehlschlags. Niemals ein Body: das Log speichert keine Inhalte.",
  "logs.table.caption": "API-Aufrufe",
  "logs.empty.title": "Keine Aufrufe gefunden",
  "logs.empty.body": "Innerhalb der Aufbewahrungsfrist des Logs passt kein Aufruf zu diesem Filter.",
  "logs.column.call": "Aufruf",
  "logs.column.status": "Status",
  "logs.column.duration": "Dauer",
  "logs.column.error": "Fehlercode",
  "logs.column.moment": "Zeitpunkt",
  "logs.duration": "{ms} ms",
  "logs.filter.status": "Status",
  "logs.filter.path": "Pfad",
  "logs.filter.path.hint": "Exakter Pfad, ohne Querystring.",
  "logs.filter.request_id": "Request-ID",
  "logs.detail.title": "API-Aufruf",
  "logs.detail.request_id": "Request-ID",
  "logs.detail.no_body": "Das Log speichert Zusammenfassungen, keine Request- oder Response-Bodies.",
  "logs.error.docs": "Was bedeutet dieser Code?",
  "billing.intro": "Was diese Organisation verbraucht hat, auf welchem Tarif sie liegt und welche Rechnungen der Abrechnungsanbieter dazu hat. Der Testmodus wird gezählt und angezeigt, aber nie berechnet.",
  "billing.plan.title": "Abonnement",
  "billing.plan.tier": "Tarif",
  "billing.plan.status": "Status",
  "billing.plan.period_end": "Ende der laufenden Periode",
  "billing.plan.period_end.none": "Noch keine Periode bekannt",
  "billing.tier.sandbox": "Sandbox",
  "billing.tier.starter": "Starter",
  "billing.tier.scale": "Scale",
  "billing.tier.enterprise": "Enterprise",
  "billing.status.active": "Bezahlt",
  "billing.status.past_due": "Zahlung fehlgeschlagen",
  "billing.status.canceled": "Gekündigt",
  "billing.unconfigured.title": "Abrechnung ist in dieser Umgebung ausgeschaltet",
  "billing.unconfigured.body": "Es ist kein Abrechnungsanbieter verbunden, daher wird nichts berechnet und das Kundenportal steht nicht zur Verfügung. Der Verbrauch unten wird trotzdem gezählt.",
  "billing.usage.title": "Verbrauch",
  "billing.usage.window": "{from} bis einschließlich {to}",
  "billing.usage.test_mode": "Sie sehen den Testmodus. Die Sandbox ist zeitlich unbegrenzt kostenlos; diese Zahlen landen nie auf einer Rechnung.",
  "billing.usage.table.caption": "Verbrauch pro Tag",
  "billing.usage.empty.title": "Noch nichts gezählt",
  "billing.usage.empty.body": "Die nächtliche Auswertung hat für diesen Zeitraum nichts erfasst. Sobald eine Sendung ausgestellt oder eine Unterschrift erfasst wird, erscheint der erste Tag hier.",
  "billing.column.day": "Tag",
  "billing.column.shipments_issued": "Ausgestellt",
  "billing.column.signatures": "Unterschriften",
  "billing.column.notifications": "Benachrichtigungen",
  "billing.column.documents": "Dokumente",
  "billing.column.storage": "Speicher",
  "billing.totals.title": "Summe in diesem Zeitraum",
  "billing.totals.storage.hint": "Speicher ist der Stand am letzten Tag, keine Summe.",
  "billing.invoices.title": "Rechnungen",
  "billing.invoices.table.caption": "Rechnungen",
  "billing.invoices.column.number": "Nummer",
  "billing.invoices.column.status": "Status",
  "billing.invoices.column.amount": "Betrag",
  "billing.invoices.column.period": "Zeitraum bis",
  "billing.invoices.column.link": "Dokument",
  "billing.invoices.status.draft": "Entwurf",
  "billing.invoices.status.open": "Offen",
  "billing.invoices.status.paid": "Bezahlt",
  "billing.invoices.status.uncollectible": "Uneinbringlich",
  "billing.invoices.status.void": "Storniert",
  "billing.invoices.empty.title": "Noch keine Rechnungen",
  "billing.invoices.empty.body": "Sobald die erste Abrechnungsperiode abgeschlossen ist, erscheint die Rechnung hier und im Kundenportal.",
  "billing.invoices.open": "Ansehen",
  "billing.portal.title": "Kundenportal",
  "billing.portal.body": "Zahlungsdaten ändern, Rechnungen herunterladen und das Abonnement einsehen geschieht beim Abrechnungsanbieter.",
  "billing.portal.button": "Kundenportal öffnen",
  "billing.portal.unavailable": "Nicht verfügbar, solange kein Abrechnungsanbieter verbunden ist.",
  "billing.portal.failed": "Das Kundenportal konnte nicht geöffnet werden. Bitte später erneut versuchen.",
  "settings.nav.security": "Sicherheit",
  "security.title": "Zwei-Faktor-Authentifizierung",
  "security.intro": "Eine Authenticator-App neben dem Anmeldelink. Für geschäftliche Nutzer einer eFTI-Plattform ist ein zweiter Faktor vorgeschrieben (DVO (EU) 2025/2243).",
  "security.enabled": "Die Zwei-Faktor-Authentifizierung ist für dein Konto aktiv.",
  "security.disabled": "Dein Konto hat noch keinen Authenticator. Ohne zweiten Faktor ist der Link in deinem Postfach der einzige Schlüssel.",
  "security.enable": "Authenticator einrichten",
  "security.disable": "Ausschalten",
  "security.regenerate": "Neue Wiederherstellungscodes",
  "security.recovery_remaining": "Noch {count} Wiederherstellungscodes übrig.",
  "security.locked": "Diese Organisation verlangt Zwei-Faktor-Authentifizierung; eine Inhaberin oder ein Administrator muss diese Anforderung zuerst aufheben.",
  "security.policy.title": "Für die gesamte Organisation",
  "security.policy.intro": "Wer noch keinen Authenticator hat, landet bei der nächsten Anfrage auf dem Einrichtungsbildschirm und nicht vor einer verschlossenen Tür.",
  "security.policy.label": "Zwei-Faktor-Authentifizierung für jedes Mitglied verlangen",
  "security.policy.hint": "Wieder ausschalten lässt bestehende Authenticator unangetastet.",
  "two_factor.setup.title": "QR-Code scannen",
  "two_factor.setup.intro": "Öffne deine Authenticator-App — 1Password, Bitwarden, Google Authenticator, Aegis — und scanne diesen Code. Gib danach die sechs Ziffern ein, die die App anzeigt.",
  "two_factor.setup.manual": "Kann dein Telefon nicht scannen? Gib diesen Schlüssel von Hand ein.",
  "two_factor.setup.qr.label": "QR-Code für deine Authenticator-App",
  "two_factor.setup.submit": "Einrichtung abschließen",
  "two_factor.code.label": "Code aus der App",
  "two_factor.code.hint": "Sechs Ziffern, dreißig Sekunden gültig.",
  "two_factor.recovery.title": "Bewahre deine Wiederherstellungscodes auf",
  "two_factor.recovery.intro": "Jeder Code funktioniert einmal und ersetzt die App, wenn du dein Telefon verlierst. Wir zeigen sie jetzt einmal und danach nie wieder.",
  "two_factor.recovery.download": "Herunterladen",
  "two_factor.recovery.acknowledge": "Ich habe sie gesichert",
  "two_factor.recovery.label": "Wiederherstellungscode",
  "two_factor.recovery.hint": "Einer der Codes, die du bei der Einrichtung gesichert hast.",
  "two_factor.prompt.title": "Bestätige, dass du es bist",
  "two_factor.prompt.body": "Gib die sechs Ziffern ein, die deine Authenticator-App gerade anzeigt.",
  "two_factor.prompt.recovery_body": "Gib einen deiner Wiederherstellungscodes ein. Jeder Code funktioniert genau einmal.",
  "two_factor.prompt.submit": "Weiter",
  "two_factor.prompt.use_recovery": "Telefon nicht zur Hand? Wiederherstellungscode verwenden",
  "two_factor.prompt.use_totp": "Doch den Code aus der App verwenden",
  "two_factor.prompt.lost": "Beides verloren? Eine Inhaberin oder ein Administrator deiner Organisation kann deinen zweiten Faktor zurücksetzen.",
  "two_factor.required.title": "Zwei-Faktor-Authentifizierung einrichten",
  "two_factor.required.body": "Diese Organisation verlangt einen zweiten Faktor. Solange du keinen Authenticator hast, bleibt der Rest der Konsole geschlossen.",
  "two_factor.done.title": "Alles erledigt",
  "two_factor.done.body": "Diese Sitzung ist bereits bestätigt.",
  "two_factor.done.continue": "Zur Konsole",
  "two_factor.error.invalid": "Dieser Code ist falsch, abgelaufen oder bereits verwendet.",
  "two_factor.error.required": "Diese Seite verlangt zuerst deinen zweiten Faktor.",
  "two_factor.error.too_many": "Zu viele Versuche. Versuche es in ein paar Minuten erneut.",
  "members.reset_two_factor": "2FA zurücksetzen",
  "members.reset_two_factor.confirm": "Zwei-Faktor-Authentifizierung von {name} löschen? Die Person muss danach selbst einen neuen Authenticator einrichten."
}
